<script setup lang="ts">
import { computed, ref } from 'vue'
import { TriangleAlert, X } from 'lucide-vue-next'
import { useTranslateKey } from '@/lib/utils'

// Hide automatically once the maintenance window is over (Europe/Berlin, CEST)
const MAINTENANCE_END = new Date('2026-10-12T07:00:00+02:00')

const { translateKey } = useTranslateKey()

const dismissed = ref(false)
const visible = computed(() => !dismissed.value && Date.now() < MAINTENANCE_END.getTime())
</script>

<template>
  <div
    v-if="visible"
    role="alert"
    class="fixed inset-x-0 bottom-0 z-[150] border-t-4 border-amber-600 bg-amber-400 px-6 py-5 text-amber-950 shadow-2xl"
  >
    <div class="mx-auto flex max-w-5xl items-start gap-4">
      <TriangleAlert class="mt-0.5 size-8 shrink-0" />
      <div class="flex-1">
        <p class="text-xl font-bold">{{ translateKey('maintenanceBanner.title') }}</p>
        <p class="mt-1 text-base">{{ translateKey('maintenanceBanner.description') }}</p>
      </div>
      <button
        type="button"
        class="shrink-0 cursor-pointer rounded-md p-1 hover:bg-amber-500"
        :aria-label="translateKey('maintenanceBanner.dismiss')"
        @click="dismissed = true"
      >
        <X class="size-6" />
      </button>
    </div>
  </div>
</template>
